import PortalHOC from './PortalHOC';

// This component is meant to be used with the EdroloSPA template.

export default PortalHOC('#admin-link-portal');
